import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
//import { useState, useEffect } from "react";
import LoginPage from "./LoginPage";
import AssessmentPage from "./AssessmentPage";
import TeacherDashboard from "./TeacherDashboard";
import KnowledgeGraphPage from "./components/KnowledgeGraph/KnowledgeGraphPage";
import EdgeReview from "./components/EdgeReview";
import SkillMasteryPage from "./components/SkillMasteryPage";
import CourseManagement from "./components/CourseManagement";
import Header from "./components/Header";
import { UserProvider, useUser } from "./contexts/UserContext";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import ChatWithKG from "./components/ChatWithKG";
import LearningAnalytics from "./LearningAnalytics"; // <-- add this
import "./App.css";

// Protected route component
function ProtectedRoute({ children }) {
  const location = useLocation();
  const { user, isLoading } = useUser();

  if (isLoading) {
    // Still checking authentication state
    return <div className="loading-screen">Loading...</div>;
  }

  if (!user) {
    // Redirect to login page
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

function AppContent() {
  const location = useLocation();
  const isKnowledgeGraph = location.pathname === "/knowledge-graph";

  return (
    <div
      className={`app-container ${
        isKnowledgeGraph ? "knowledge-graph-layout" : ""
      }`}
    >
      <Header />

      <main className="app-main">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/assessments"
            element={
              <ProtectedRoute>
                <AssessmentPage />
              </ProtectedRoute>
            }
          >
            <Route index element={<AssessmentPage />} />
            <Route path=":assessmentId" element={<AssessmentPage />}>
              <Route path=":questionId" element={<AssessmentPage />} />
            </Route>
          </Route>
          <Route
            path="/teacher"
            element={
              <RoleProtectedRoute allowedRoles={["instructor"]}>
                <TeacherDashboard />
              </RoleProtectedRoute>
            }
          />
          <Route
          path="/learning-analytics"
          element={
            <RoleProtectedRoute allowedRoles={["instructor"]}>
              <LearningAnalytics />
            </RoleProtectedRoute>
          }
        />
          <Route
            path="/knowledge-graph"
            element={
              <ProtectedRoute>
                <KnowledgeGraphPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edge-review"
            element={
              <ProtectedRoute>
                <EdgeReview />
              </ProtectedRoute>
            }
          />
          <Route
          path="/chat-with-kg"
          element={
            <ProtectedRoute>
              <ChatWithKG />
            </ProtectedRoute>
          }
              />
          <Route
            path="/courses"
            element={
              <ProtectedRoute>
                <CourseManagement />
              </ProtectedRoute>
            }
          />
          <Route path="/mastery" element={<SkillMasteryPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </Router>
  );
}

export default App;
